// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 25 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M18.8762 3H5.57645L1.22632 12.7878V22H23.2263V12.7878L18.8762 3ZM3.76508 12L6.87619 5L17.5764 5L20.6876 12L3.76508 12ZM7.23022 16V18.0039H5.22632V16H7.23022ZM11.2302 16V18.0039H9.22632V16H11.2302Z"}}]};

const WidgetFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'widget-filled',
    ref,
    icon: element,
  },
));

WidgetFilledIcon.displayName = 'WidgetFilledIcon';

export default WidgetFilledIcon;
